import { ValidatorTypes } from "../../../util/validators";

export const supplierContactFields = {
    isPrimary: {
        name: "isPrimary",
        label: "Set as Primary",
        type: "checkbox",
        touched: false,
        error: false,
        valid: true,
        value: false,
        dataCy: "primary-contact-checkbox",
    },
    firstName: {
        name: "firstName",
        label: "Given Name(s)",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "first-name-input",
        validation: [ValidatorTypes.OPTIONAL],
    },
    lastName: {
        name: "lastName",
        label: "Last Name",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "last-name-input",
        validation: [ValidatorTypes.OPTIONAL],
    },
    email: {
        name: "email",
        label: "Email",
        type: "email",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "email-input",
        validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.EMAIL],
    },
    phoneNumber: {
        name: "phoneNumber",
        label: "Phone Number",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "phone-number-input",
        validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.PHONE_NUMBER],
    },
    designation: {
        name: "designation",
        label: "Job Role",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "designation-input",
        validation: [ValidatorTypes.OPTIONAL],
    },
}